import { ChangeDetectorRef, Component, OnInit, OnDestroy } from "@angular/core";
import { RouterOutlet, Router, NavigationEnd } from "@angular/router";
import { NzSpinModule } from "ng-zorro-antd/spin";
import { SharedService } from "./services/shared.service";
import { filter, Subscription } from "rxjs";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  imports: [RouterOutlet, NzSpinModule],
  standalone: true,
})
export class AppComponent implements OnInit, OnDestroy {
  isSpinnerShow: boolean = false;
  private routerSubscription?: Subscription;

  constructor(
    public sharedService: SharedService,
    private changeDetector: ChangeDetectorRef,
    private router: Router
  ) {}

  ngOnInit(): void {
    // Scroll to top on route change
    this.routerSubscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        // Scroll window and document to top
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        
        // Scroll common scrollable containers to top after a short delay
        // to ensure DOM is updated
        setTimeout(() => {
          // Target specific known scrollable containers
          const containerSelectors = [
            '.layout-container',
            '.panel-content',
            '.left-panel',
            '.right-panel',
            '.editor-container',
            '.workspace',
            '.main-layout'
          ];
          
          containerSelectors.forEach(selector => {
            const elements = document.querySelectorAll(selector);
            elements.forEach((element: any) => {
              if (element && typeof element.scrollTop !== 'undefined') {
                element.scrollTop = 0;
              }
            });
          });
        }, 100);
      });
  }

  ngAfterContentChecked() {
    this.sharedService.isSpinnerShow.subscribe((res) => {
      this.isSpinnerShow = res;
    });
    this.changeDetector.detectChanges();
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }
}
